import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPolicyService } from './policyService';

export const getPolicy = createAsyncThunk(
  'policy/get',
  async (type, { rejectWithValue }) => {
    try {
      const response = await getPolicyService(type);
      if (response.status) {
        return response.data; // Now normalized to .data
      }
      return rejectWithValue(response.message || 'Failed to fetch policy');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);
